/**
 * Submission verification API client for the AI service's
 * /submission-verification/* endpoints (via aiApi). Extracts product info
 * from a submission URL and verifies extracted data against a bounty, in
 * either "create" or "accept" mode.
 * Consumed by the SubmissionCreate and SubmissionDisplay pages.
 */
import { aiApi } from "@/lib/axios";
import {
    SubmissionVerificationResult,
    NestedSubmissionVerificationExtractedDataResponse,
    SubmissionVerificationExtractedData,
} from "@/types/submission";

export type SubmissionVerificationType = "create" | "accept";

export const SubmissionVerificationAPI = {
    extractProductInfoForUrl: async (url: string) => {
        const { data } = await aiApi.post<NestedSubmissionVerificationExtractedDataResponse>(
            `/submission-verification/extract-product-info`,
            { url }
        );
        return data;
    },
    verifySubmission: async (
        extractedData: SubmissionVerificationExtractedData,
        type: SubmissionVerificationType
    ) => {
        const { data } = await aiApi.post<SubmissionVerificationResult>(
            `/submission-verification/verify?type=${type}`,
            { extractedData }
        );
        return data;
    },
};
